import React from 'react';
export var Container = function Container(props) {
  return React.createElement("svg", {
    className: props.className,
    width: 24,
    height: 24,
    "aria-hidden": true,
    viewBox: "0 0 24 24"
  }, props.children);
};

var OuterRing = function OuterRing(props) {
  return React.createElement("path", {
    className: props.className,
    d: "M12,2A10,10,0,1,1,2,12,10,10,0,0,1,12,2m0-2A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z"
  });
};

var InnerRing = function InnerRing(props) {
  return React.createElement("circle", {
    className: props.className,
    cx: "12",
    cy: "12",
    r: "8"
  });
};

var Background = function Background(props) {
  return React.createElement("circle", {
    className: props.className,
    cx: "12",
    cy: "12",
    r: "12"
  });
};

export var RadioIndicatorSVG = function RadioIndicatorSVG(props) {
  return React.createElement(Container, {
    className: props.containerClassName
  }, React.createElement(Background, {
    className: props.backgroundClassName
  }), React.createElement(OuterRing, {
    className: props.outerRingClassName
  }), React.createElement(InnerRing, {
    className: props.innerRingClassName
  }));
};